import http from './http-common';

class UsersService {
  getAll() {
    return http.get('/users');
  }
  getCompanyEmail() {
    return http.get('/users/DomainEmail');
  }
  add(data) {
    return http.post('/users/add',data);
  }
  edit(data,id) {
    return http.put(`/users/${id}`,data);
  }
  UserIsDeletedService(data,id) {
    return http.put(`/users/IsDeleted/${id}`,data);
  }
  editWithPassword(data,id) {
    return http.put(`/users/withPassword/${id}`,data);
  }

  getThreeInputsForList(data) {
    return http.post('/threeInputs/list',data);
  }
  addMultipleInputs(data) {
    return http.post('/threeInputs/add',data);
  }
  editMultipleInputs(data) {
    return http.put('/threeInputs/update',data);
  }
  getForList() {
    return http.get('/users/getForList');
  }
}

export default new UsersService();
